module.exports = __webpack_public_path__ + "static/media/what-is-it.ae6ad600.md";